export default __webpack_public_path__ + "static/media/Ovalle.bc8a8330.svg";